<template>
  <div>
    <div v-if="this.newArbitre" class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Inscription arbitre</h3>
            <button type="button"
                    class="btn btn-xs btn-default btn-flat margin pull-right"
                    style="margin-top: 0;margin-bottom: 0;"
                    @click="resetInscriptionForm()"
            >
              Réinitialiser le formulaire
            </button>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group"
                     :class="{'has-error': errors.has('newArbitre[membre]') }">
                  <label for="searchmember">Arbitre</label>
                  <v-select v-model="newArbitre.membre"
                            label="fullName"
                            :filterable="false"
                            :taggable="false"
                            :debounce="250"
                            :on-search="SearchMembersResponse"
                            :options="ArrayMembersSearch">
                                            <span slot="selected-option" slot-scope="props">
                                                <router-link :to="{ name: 'Member', params: { member_id: props.selectedOption.id }}">
                                                {{ props.selectedOption.fullName}}  - {{props.selectedOption.age}}
                                                </router-link>
                                            </span>
                    <template slot="option" slot-scope="props">
                                            <span :class="props.item.licencie ? 'text-green' : 'text-red'">
                                                {{props.item.fullName}} - {{props.item.club.club}}
                                            </span>
                    </template>
                  </v-select>
                </div>

                <date-avant-date-apres
                  :dateDebutPrefill="this.getCompetition.date_debut"
                  :dateFinPrefill="this.getCompetition.date_fin"
                  @onDateDebutChange="setDateDebut"
                  @onDateFinChange="setDateFin"
                ></date-avant-date-apres>

              </div>
            </div>
          </div>
          <div class="overlay" v-if="loading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
          <div class="box-footer">
            <input type="submit"
                   @click.prevent="addInscription()"
                   :disabled="!isFormValid()"
                   value="Ajouter"
                   class="btn btn-primary pull-right"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <b-col md="9" class="my-1">
              <h3 class="box-title">Listing des arbitres: {{getCompetition.arbitres.length}} résultat{{getCompetition.arbitres.length>1 ? 's':''}}</h3>
            </b-col>
            <b-col md="3" class="my-1">
              <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
            </b-col>
          </div>
          <div class="box-body">
            <b-table
              id="tableListingAllCompetitions"
              v-if="getCompetition!=null"
              responsive bordered striped hover
              :items="getCompetition.arbitres"
              :fields="columnsListingInscriptions"
              :current-page="pagination_meta.current_page"
              :per-page="pagination_meta.per_page"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :no-local-sorting="false"
              :no-sort-reset="true"
              :empty-text="'Aucun résultat'"
              :empty-filtered-text="'Aucun résultat'"
              :filter="filter"
              :busy.sync="loading"
              :sort-compare="sortCompareAdvanced"
              foot-clone
              show-empty
            >
              <template slot="actions" slot-scope="data">
<!--                <button v-if="!isEditing(data.item.id)"-->
<!--                        @click.prevent="editItem(data.item)"-->
<!--                        class="btn btn-default padding2">-->
<!--                  <i class="glyphicon glyphicon-pencil"></i>-->
<!--                </button>-->
                <button v-if="!isEditing(data.item.id)"
                        @click.prevent="removeInscriptions(data.item.id)"
                        class="btn btn-default padding2">
                  <i class="glyphicon glyphicon-remove"></i>
                </button>
                <button v-if="isEditing(data.item.id)"
                        @click.prevent="validEditing(data.item.id)"
                        class="btn btn-primary padding2">
                  <i class="glyphicon glyphicon-ok"></i>
                </button>
                <button v-if="isEditing(data.item.id)"
                        @click.prevent="cancelEditing(data.item.id)"
                        class="btn btn-danger padding2">
                  <i class="glyphicon glyphicon-ban-circle"></i>
                </button>
              </template>

              <template slot="membre.nom" slot-scope="data">
                <router-link
                  :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                  {{data.item.membre.nom }}
                </router-link>
              </template>

              <template slot="membre.prenom" slot-scope="data">
                <router-link
                  :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                  {{data.item.membre.prenom }}
                </router-link>
              </template>

              <template slot="date_debut" slot-scope="data">
                {{ formatDate(data.item.date_debut,'YYYY-MM-DD','DD/MM/YYYY') }}
              </template>

              <template slot="date_fin" slot-scope="data">
                {{ formatDate(data.item.date_fin,'YYYY-MM-DD','DD/MM/YYYY')}}
              </template>

            </b-table>
            <b-pagination size="md"
                          :total-rows="getCompetition.arbitres.length"
                          v-model="pagination_meta.current_page"
                          :per-page="pagination_meta.per_page">
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import vSelect from '../../Communs/vSelect/index'
    import ListSelectClub from '../../Communs/listeSelectClub'
    import DateAvantDateApres from '../../Communs/DateAvantDateApres'

    require('../../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker')
    require('../../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')

    var _ = require('underscore')
    var moment = require('moment')

    export default {
        props: {},
        data() {
            return {
                arrayEdits: [],
                arrayInscriptionsEdits: [],
                arrayOriginal: [],
                sortBy: "membre.nom",
                sortDesc: null,
                filter: null,
                inscriptions: null,
                listingCompetitions: [],
                loadingListingCompetition: true,
                loading: false,
                isBusy: false,
                disabledBtn: false,
                current_page: 1,
                periodeDu: null,
                periodeAu: null,
                typeSelectedForFilter: 0,
                reset: false,
                otherPlaceSelected: false,
                newArbitre: null,
                previousInscription: null,
                previousRequest: false,
                ArrayMembersSearch: [],
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 1
                },
                columnsListingInscriptions: [
                    {
                        label: 'Nom',
                        key: 'membre.nom',
                        sortable: true,
                    },
                    {
                        label: 'Prénom',
                        key: 'membre.prenom',
                        sortable: true,
                    },
                    {
                        label: 'Date début',
                        key: 'date_debut',
                        sortable: false,
                    },
                    {
                        label: 'Date fin',
                        key: 'date_fin',
                        sortable: true,
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getCompetition: 'getCompetition',
            }),
        },
        mounted: function () {
            var these = this
            this.resetInscriptionForm()
            // this.getTableListingCompetition();
            this.$nextTick(function () {
                // this.loadListeClub()
            })
        },
        created() {
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                // vm.getTableListingCompetition();
                // vm.loadStatutsCompetitions()
            })
        },
        watch: {
            // 'newArbitre.membre': function (membreSelectionne) {
            //     if (!membreSelectionne)
            //         return;
            // },
        },
        components: {
            vSelect,
            ListSelectClub,
            DateAvantDateApres
        },
        methods: {
            ...mapActions({
                setListeClub: 'setListeClub',
            }),
            isFormValid: function () {
                return this.newArbitre.membre != null
                    && this.newArbitre.date_debut != null
                    && this.newArbitre.date_fin != null
            },
            resetInscriptionForm: function () {
                if (this.newArbitre) {
                    this.previousInscription = {
                        id_membre: this.newArbitre.id_membre,
                        date_debut: this.newArbitre.date_debut,
                        date_fin: this.newArbitre.date_fin,
                    }
                }
                this.newArbitre = {
                    membre: null,
                    id_compet: this.getCompetition.id,
                    date_debut: this.getCompetition.date_debut,
                    date_fin: this.getCompetition.date_fin,
                }
            },
            SearchMembersResponse: function (search, loading) {
                if (search.length <= 2)
                    return;
                let these = this;
                loading(true)
                this.$http.post(this.getRoute("memberSearch"), {q: search}, {
                    before(request) {
                        if (these.previousRequest)
                            these.previousRequest.abort();
                        these.previousRequest = request;
                    }
                }).then(resp => {
                    loading(false)
                    let idsAlreadyExists = "";
                    this.ArrayMembersSearch = resp.data;
                    this.getCompetition.arbitres.forEach((item) => {
                        this.ArrayMembersSearch = _.reject(this.ArrayMembersSearch, function (item2) {
                            return item.membre.id == item2.id
                        });
                    })
                    this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
                })
            },
            constructForm: function () {
                return {
                    id_membre: this.newArbitre.membre.id,
                    id_compet: this.newArbitre.id_compet,
                    date_debut: this.formatDate(this.newArbitre.date_debut, "DD/MM/YYYY", "YYYY-MM-DD"),
                    date_fin: this.formatDate(this.newArbitre.date_fin, "DD/MM/YYYY", "YYYY-MM-DD"),
                }
            },
            constructFormInscriptionsUpdate: function (inscription) {
                return {
                    id: inscription.id,
                    id_compet: inscription.id_compet,
                    date_debut: this.formatDate(inscription.date_debut, "DD/MM/YYYY", "YYYY-MM-DD"),
                    date_fin: this.formatDate(inscription.date_fin, "DD/MM/YYYY", "YYYY-MM-DD"),
                }
            },
            addInscription: function () {
                this.disabledBtn = true;
                this.loading = true
                let self = this;
                this.$http.post(this.getRoute('Secretariat.competition.storeArbitre'), this.constructForm()).then(function (response) {
                    self.$noty.success(this.newArbitre.membre.fullName + " a été ajouté à la competition en tant qu'arbitre")
                    this.disabledBtn = false
                    this.getCompetition.arbitres = response.body
                    this.loading = false
                    this.resetInscriptionForm();
                    this.ArrayMembersSearch = []
                }, (response) => {
                    self.$noty.error("Erreur dans l'ajout de l'arbitre")
                    this.disabledBtn = false
                    this.loading = false
                });
            },
            validEditing: function (id) {
                this.loading = true
                let inscriptionsToUpdate = _.find(this.arrayInscriptionsEdits, function (item) {
                    return item.id == id;
                });
                let self = this;
                this.$http.post(this.getRoute('Secretariat.competition.updateArbitre'),
                    this.constructFormInscriptionsUpdate(inscriptionsToUpdate)).then(function (response) {
                    self.$noty.success("L'inscription en tant qu'arbitre a bien été modifiée.")
                    this.disabledBtn = false
                    this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                        return item == id;
                    });
                    this.arrayInscriptionsEdits = _.reject(this.arrayInscriptionsEdits, function (item) {
                        return item.id == id;
                    });

                    let inscriptionsToUpdateInTable = _.find(this.getCompetition.arbitres, function (item) {
                        return item.id == id;
                    });

                    _.each(response.body, (item, index) => {
                        inscriptionsToUpdateInTable[index] = item;
                    })
                    this.loading = false
                }, (response) => {
                    self.$noty.error("Erreur dans la modification de l'inscription en tant qu'arbitre")
                    this.disabledBtn = false
                    this.loading = false
                });
            },
            removeInscriptions: function (id) {
                let self = this;
                this.$http.post(this.getRoute('Secretariat.competition.deleteArbitre'), {id: id}).then(function (response) {
                    self.$noty.success("L'inscription en tant qu'arbitre a bien été supprimée")
                    this.disabledBtn = false
                    this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                        return item == id;
                    });
                    this.arrayInscriptionsEdits = _.reject(this.arrayInscriptionsEdits, function (item) {
                        return item.id == id;
                    });
                    this.getCompetition.arbitres = _.reject(this.getCompetition.arbitres, function (item) {
                        return item.id == id;
                    });
                }, (response) => {
                    self.$noty.error("Erreur dans la suppresion de l'arbitre")
                    this.disabledBtn = false
                });
            },
            flatten: function (obj) {
                var root = {};
                (function tree(obj, index) {
                    var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
                    for (var key in obj) {
                        if (!obj.hasOwnProperty(key)) continue;
                        root[index + key + suffix] = obj[key];
                        if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
                        if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
                    }
                })(obj, "");
                return root;
            },
            sortCompareAdvanced: function (a, b, key) {
                if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
                } else {
                    // Stringify the field data and use String.localeCompare
                    return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
                        numeric: true
                    })
                }
            },
            getLabelFromKey: function (key) {
                switch (key) {
                    case 'noire':
                        return 'Dan';
                        break;

                    default:
                        return key.charAt(0).toUpperCase() + key.slice(1);
                        break;
                }
            },
            currentYear: function () {
                return moment().year();
            },
            console: function (event) {
                console.log(event);
            },
            setDateDebut: function (value) {
                this.newArbitre.date_debut = value;
            },
            setDateFin: function (value) {
                this.newArbitre.date_fin = value;
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },

            cancelEditing: function (id) {
                this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                    return item == id;
                });
                this.arrayInscriptionsEdits = _.reject(this.arrayInscriptionsEdits, function (item) {
                    return item.id == id;
                });

            },
            getObjectEditable: function (id) {
                return _.find(this.arrayInscriptionsEdits, function (item) {
                    return item.id == id;
                })
            },
            editItem: function (item) {
                this.arrayEdits.push(item.id);
                this.arrayInscriptionsEdits.push(item)
            },
            isEditing: function (id) {
                return _.contains(this.arrayEdits, id)
            },
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/Secretariat/Competition/InscriptionsArbitres.vue